<template>
  <InvestorForm ref="form" mode="create" />
</template>

<script>
import InvestorForm from '@/components/create-investors/InvestorForm'
import { buildMetaHead } from '@/helpers/meta'

export default {
  name: 'PageClientInvestorsNew',
  layout: 'plain',
  components: {
    InvestorForm
  },
  head() {
    return buildMetaHead({
      title: 'Create investor profile',
      path: this.$route.path
    })
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$refs.form.beforeRouteEnter(to, from, next)
    })
  },
  beforeRouteLeave(to, from, next) {
    // https://stackoverflow.com/questions/42045433/vue-router-beforerouteleave-doesnt-stop-subcomponents
    return this.$refs.form.beforeRouteLeave(to, from, next)
  }
}
</script>
